import React, { useState } from "react";
import {
    formatSingleDate,
    parseSingleDate,
    toInputFormats,
} from "./DatePicker.lib";
import styles from "./DatePicker.module.scss";

export const MonthRangeDayInput = ({
    id,
    label,
    value,
    placeholder,
    inputFormat,
    onCommit,
}: {
    id: string;
    label: string;
    value?: string;
    placeholder?: string;
    inputFormat: string | readonly string[];
    onCommit: (nextValue: string | undefined) => void;
}) => {
    const displayFormat = toInputFormats(inputFormat)[0] ?? "MM/dd/yyyy";
    const formattedValue = formatSingleDate(value, displayFormat);
    const [isEditing, setIsEditing] = useState(false);
    const [inputValue, setInputValue] = useState("");

    const commitInputValue = () => {
        if (inputValue.trim().length === 0) {
            onCommit(undefined);
            return;
        }
        const parsedValue = parseSingleDate(inputValue, inputFormat);
        if (parsedValue !== undefined) {
            onCommit(parsedValue);
        }
    };

    return (
        <div className={styles.monthRangeDayField}>
            <label htmlFor={id}>{label}</label>
            <div className={styles.monthRangeDayInput}>
                <input
                    id={id}
                    value={isEditing ? inputValue : formattedValue}
                    placeholder={placeholder ?? displayFormat}
                    onFocus={() => {
                        setInputValue(formattedValue);
                        setIsEditing(true);
                    }}
                    onChange={(event) => setInputValue(event.target.value)}
                    onKeyDown={(event) => {
                        if (event.key !== "Enter") {
                            return;
                        }
                        event.currentTarget.blur();
                    }}
                    onBlur={() => {
                        commitInputValue();
                        setIsEditing(false);
                    }}
                />
            </div>
        </div>
    );
};
